import { React } from "react";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom";

import App from "./App";

import "./index.css";
import "semantic-ui-css/semantic.min.css";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { QueryClientProvider, QueryClient } from "react-query";

const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
);

// ReactDOM.render(
//   <QueryClientProvider client={queryClient}>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </QueryClientProvider>,
//   document.getElementById("root")
// );

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
